import React from 'react';
import Button from './Button';

const icons = {
  dashboard: (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-2"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>
  ),
  products: (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-2"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M16 3v4M8 3v4"/></svg>
  ),
  stocks: (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-2"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M16 3v4M8 3v4"/></svg>
  ),
  sales: (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" className="mr-2"><path d="M6 6h15M6 12h15M6 18h15M3 6v.01M3 12v.01M3 18v.01"/></svg>
  ),
};

const tabData = [
  { key: 'dashboard', label: 'Tableau de Bord', icon: icons.dashboard },
  { key: 'products', label: 'Produits', icon: icons.products },
  { key: 'stocks', label: 'Stocks', icon: icons.stocks },
  { key: 'sales', label: 'Ventes & SAV', icon: icons.sales },
];

export default function Tab({ active, onChange, className = '', tabData: customTabData }) {
  const tabs = customTabData || tabData;
  return (
    <div className={`flex-nowrap flex gap-2 py-2 px-2 rounded-full bg-white/30 backdrop-blur-md border border-white/70 overflow-x-auto whitespace-nowrap mb-4 ${className}`} style={{ WebkitOverflowScrolling: 'touch' }}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`flex items-center gap-2 px-5 py-2 font-heading text-xs rounded-full transition-all duration-100 ease-out whitespace-nowrap
            ${active === tab.key
              ? 'bg-white text-blue-gray-900 font-semibold shadow-sm'
              : 'bg-transparent text-blue-gray-700 font-normal hover:bg-blue-gray-100'}
          `}
          onClick={() => onChange(tab.key)}
          type="button"
          style={{ border: 'none', outline: 'none' }}
        >
          {tab.icon && (
            <span className="flex items-center justify-center h-5 w-5">
              {React.cloneElement(tab.icon, { className: 'h-5 w-5 mr-2', style: { display: 'block' } })}
            </span>
          )}
          <span className="whitespace-nowrap">{tab.label}</span>
        </button>
      ))}
    </div>
  );
} 